export const sliderPC = [
    {
        id:1,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/03/banner/aiohp-800-200-800x200.png'
    
    },
    {
        id:2,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/07/banner/mayin-800-200-800x200.png'
    
    },
    {
        id:3,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/05/banner/800-200-800x200-212.png'
    
    },
    {
        id:4,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/06/banner/800-200-800x200-165.png'
    
    },
  
    {
        id:5,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/06/banner/18-imac-800-200-800x200.png'
    
    }
   
]

export const bannerPC =[
    {
        id:1,
        title:'lorem',
        url:'https://cdn.tgdd.vn/2022/05/banner/lenovo-may-tinh390-97-390x97.png'
    },
    {
        id:2,
        title:'lorem',
        url:'https://cdn.tgdd.vn/2022/06/banner/Xa-hang-Laptop-2-390x97-2.png'
    }
]


export const categories = [
    {
        id : 1 ,
        name: 'PC, máy in',
        title: 'sản phẩm PC, máy in',
        childCate: [
            {
                nameChild:'Máy in',
                imgUrl: 'https://cdn.tgdd.vn/Category/5693/Mayin2x-80x80-9.png'
            },
            {
                nameChild:'Mực in',
                imgUrl: 'https://cdn.tgdd.vn/Category/1262/Mucin2x-80x80.png'
            },
            {
                nameChild:'Màn hình máy tính',
                imgUrl: 'https://cdn.tgdd.vn/Category/5697/manhinh-80x80.png'
            },
            {
                nameChild:'Máy tính để bàn',
                imgUrl: 'https://cdn.tgdd.vn/Category/5698/maytinhbo-80x80.png'
            }
        ]
    }
]

export const products = [
    {
        id: 1,
        category: 'PC, máy in',
        product: 'Máy in',
        total: 18
    },
    {
        id: 2,
        category: 'PC, máy in',
        product: 'Mực in',
        total: 18
    },
    {
        id: 3,
        category: 'PC, máy in',
        product: 'Màn hình máy tính',
        total: 16
    },
    {
        id: 4,
        category: 'PC, máy in',
        product: 'Máy tính để bàn',
        total: 17
    }
]

export const options = [
    {
        value: 'Bán chạy',
        text: 'Bán chạy'
    },
    {
        value: '% Giảm',
        text: '% Giảm'
    },
    {
        value: 'Giá cao đên thấp',
        text: 'Giá cao đến thấp'
    },
    {
        value: 'Giá thấp đến cao',
        text: 'Giá thấp đến cao'
    }
]


export const company = [
    {
        id: 1,
        title: 'Canon',
        url: 'https://cdn.tgdd.vn/Brand/1/Canon5693-b46-220x48-220x48.jpeg'
    },
    {
        id: 2,
        title: 'Brother',
        url: 'https://cdn.tgdd.vn/Brand/1/Brother5693-b32-220x48-220x48.jpeg'
    },
    {
        id: 3,
        title: 'HP',
        url: 'https://cdn.tgdd.vn/Brand/1/logo-hp-149x40-6.png'
    },
    {
        id: 4,
        title: 'Apple',
        url: 'https://cdn.tgdd.vn/Brand/1/logo-apple-220x48-2.png'
    },
    {
        id: 5,
        title: 'Asus',
        url: 'https://cdn.tgdd.vn/Brand/1/logo-asus-149x40-10.png'
    },
    {
        id: 6,
        title: 'Samsung',
        url: 'https://cdn.tgdd.vn/Brand/1/logo-samsung-220x48.png'
    },
    {
        id: 7,
        title: 'Lenovo',
        url: 'https://cdn.tgdd.vn/Brand/1/logo-lenovo-149x40-5.png'
    },
    {
        id: 8,
        title: 'View Sonic',
        url: 'https://cdn.tgdd.vn/Brand/1/viewsonictgdd-220x48.png'
    },
    {
        id: 9,
        title: 'Dell',
        url: 'https://cdn.tgdd.vn/Brand/1/logo-dell-149x40-1.png'
    }

]


export const listProducts =[
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 2,
        label: false,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    },
    {
        id: 1,
        label: true,
        name: 'Máy in Laser Trắng Đen HP 107w WiFi (4ZB78A)',
        url: 'https://cdn.tgdd.vn/Products/Images/5693/241926/may-in-laser-trang-den-hp-107w-wifi-4zb78a-thumb-600x600.jpg',
        price_old: '3.090.000₫',
        price_new: '2.990.000₫',
        rating: 'star'


    }
]

export const list_box_filter_printer = [
    {
        id:1,
        title: 'Hãng',
        name:'brand',
        dropDown: [
            {
                id:1,
                img:'https://cdn.tgdd.vn/Brand/1/Canon5693-b46-220x48.jpg'
            },
            {
                id:2,
                img:'https://cdn.tgdd.vn/Brand/1/Brother5693-b32-220x48.jpg'
            },
            {
                id:3,
                img:'https://cdn.tgdd.vn/Brand/1/logo-hp-149x40-3.png'
            }
        ],
    },
    {
        id:2,
        title: 'Loại máy',
        name:'categories',
        dropDown: [
            {
                content:'In laser trắng đen'
            },
            {
                content:'In phun trắng đen'
            },
            {
                content:'In phun màu'
            },
            {
                content:'In laser màu'
            }
        ],
    },
    {
        id:3,
        title: 'Chức năng',
        name:'feature',
        dropDown: [
            {
                content:'Copy'
            },
            {
                content:'Scan (Màu)'
            },
            {
                content:'In wifi'
            },
            {
                content:'In 1 mặt'
            },
            {
                content:'In 2 mặt tự động' 
            },
        ],
    },
    
    
]


export const list_box_filter_screen = [
    {
        id:1,
        title: 'Hãng',
        name:'brand',
        dropDown: [
            {
                id:1,
                img:'https://cdn.tgdd.vn/Brand/1/logo-asus-149x40-8.png'
            },
            {
                id:2,
                img:'https://cdn.tgdd.vn/Brand/1/logo-samsung-220x48.png'
            },
            {
                id:3,
                img:'https://cdn.tgdd.vn/Brand/1/logo-lenovo-149x40-5.png'
            },
            {
                id:4,
                img:'https://cdn.tgdd.vn/Brand/1/viewsonictgdd-220x48.png'
            },
            {
                id:5,
                img:'https://cdn.tgdd.vn/Brand/1/logo-dell-149x40-1.png'
            }
        ],
    },
    {
        id:2,
        title: 'Giá',
        name:'drop-left price',
        dropDown: [
            {
               content: 'Dưới 5 triệu', 
               maxPrice:5000000 ,
               minPrice: 0               
            },
            {
                content: 'Từ 5-7 triệu',
                maxPrice: 7000000 ,
                minPrice: 5000000
            },
            {
                content: 'Từ 7-10 triệu',
                maxPrice: 10000000,
                minPrice: 7000000
            },
            {
                content: 'Trên 10 triệu',
                maxPrice: 10000000,
                minPrice: 10000000
            },
           
        ],
    },

    {
        id:3,
        title: 'Kích thước màn hình',
        name:'dimen',
        dropDown: [
            {
               content: '23.8 inch',
            },
            {
                content:'24 inch',
            },
            {
                content: '24.5 inch',
            },
            {
                content: '27 inch',
            },
            {
                content: '32 inch',
            },
           
        ],
    },

    {
        id:4,
        title: 'Độ phân giải',
        name:'shows',
        dropDown: [
            {
               content: 'Full HD',
            },
            {
                content:'2K',
            },
          
           
        ],
    },
    {
        id:5,
        title: 'Tần số quét',
        name:'frequency',
        dropDown: [
            {
               content: '60 Hz',
            },
            {
                content:'75 Hz',
            },
            {
                content: '144 Hz',
            },
            {
                content:'165 Hz',
            },
            {
               content: '240 Hz',
            },
            {
                content:'280 Hz',
            }, 
          
           
        ],
    },

    {
        id:6,
        title: 'Tiện ích',
        name:'utility',
        dropDown: [
            {
               content: 'Màn hình điều chỉnh được độ cao',
            },
            {
                content:'Màn hình xoay 90 độ',
            },
            {
                content: 'Có tích hợp loa',
            },
            
          
           
        ],
    },
]

export const list_box_filter_PC = [
    {
        id:1,
        title: 'Hãng',
        name:'brand',
        dropDown: [
            {
                id:1,
                img:'https://cdn.tgdd.vn/Brand/1/logo-asus-149x40-8.png'
            },
            {
                id:2,
                img:'https://cdn.tgdd.vn/Brand/1/logo-samsung-220x48.png'
            },
            {
                id:3,
                img:'https://cdn.tgdd.vn/Brand/1/logo-lenovo-149x40-5.png'
            },
            {
                id:4,
                img:'https://cdn.tgdd.vn/Brand/1/viewsonictgdd-220x48.png'
            },
            {
                id:5,
                img:'https://cdn.tgdd.vn/Brand/1/logo-dell-149x40-1.png'
            }
        ],
    },
    {
        id:2,
        title: 'Giá',
        name:'price',
        dropDown: [
            {
                content: 'Dưới 5 triệu', 
                maxPrice:5000000 ,
                minPrice: 0               
            },
            {
                content: 'Từ 5-7 triệu',
                maxPrice: 7000000 ,
                minPrice: 5000000
            },
            {
                content: 'Từ 7-10 triệu',
                maxPrice: 10000000,
                minPrice: 7000000
            },
            {
                content: 'Trên 10 triệu',
                maxPrice: 10000000,
                minPrice: 10000000
            },
           
        ],
    },

    {
        id:3,
        title: 'Kích thước màn hình',
        name:'dimen',
        dropDown: [
            {
               content: '23.8 inch',
            },
            {
                content:'24 inch',
            },
            {
                content: '24.5 inch',
            },
            {
                content: '27 inch',
            },
            {
                content: '32 inch',
            },
           
        ],
    },

    {
        id:4,
        title: 'Độ phân giải',
        name:'shows',
        dropDown: [
            {
               content: 'Full HD',
            },
            {
                content:'2K',
            },
          
           
        ],
    },
    {
        id:5,
        title: 'Tần số quét',
        name:'frequency',
        dropDown: [
            {
               content: '60 Hz',
            },
            {
                content:'75 Hz',
            },
            {
                content: '144 Hz',
            },
            {
                content:'165 Hz',
            },
            {
               content: '240 Hz',
            },
            {
                content:'280 Hz',
            }, 
          
           
        ],
    },

    {
        id:6,
        title: 'Tiện ích',
        name:'utility',
        dropDown: [
            {
               content: 'Màn hình điều chỉnh được độ cao',
            },
            {
                content:'Màn hình xoay 90 độ',
            },
            {
                content: 'Có tích hợp loa',
            },
            
          
           
        ],
    },
]



export const list_company_ink = [
    {
        id: 1,
        title: 'Canon',
        url: 'https://cdn.tgdd.vn/Brand/1/Canon5693-b46-220x48-220x48.jpeg'
    },
    {
        id: 2,
        title: 'Brother',
        url: 'https://cdn.tgdd.vn/Brand/1/Brother5693-b32-220x48-220x48.jpeg'
    },
    {
        id: 3,
        title: 'HP',
        url: 'https://cdn.tgdd.vn/Brand/1/logo-hp-149x40-6.png'
    },
]


export const list_company_screen = [
    {
        id:1,
        title: 'asus',
        url:'https://cdn.tgdd.vn/Brand/1/logo-asus-149x40-8.png'
    },
    {
        id:2,
        title: 'samsung',
        url:'https://cdn.tgdd.vn/Brand/1/logo-samsung-220x48.png'
    },
    {
        id:3,
        title: 'lenovo',
        url:'https://cdn.tgdd.vn/Brand/1/logo-lenovo-149x40-5.png'
    },
    {
        id:4,
        title: 'sonic',
        url:'https://cdn.tgdd.vn/Brand/1/viewsonictgdd-220x48.png'
    },
    {
        id:5,
        title: 'dell',
        url:'https://cdn.tgdd.vn/Brand/1/logo-dell-149x40-1.png'
    }
]
